import React, { useEffect, useState } from 'react';
import './MobileRedirect.scss';

const APP_STORE_URL = 'https://apps.apple.com/co/app/firewatch-ai-space-monitoring/id6498717343';
const GOOGLE_PLAY_URL = 'https://play.google.com/store/apps/details?id=com.nativefirewatch&pcampaignid=web_share&pli=1';
const STORAGE_KEY = 'firewatch_mobile_redirect_dismissed';

export default function MobileRedirect() {
  const [showRedirect, setShowRedirect] = useState(false);

  useEffect(() => {
    // Check if user has already dismissed the redirect
    try {
      const dismissed = localStorage.getItem(STORAGE_KEY);
      if (dismissed === 'true') {
        return;
      }
    } catch (error) {
      // localStorage might not be available (rare)
      console.error('Error accessing localStorage:', error);
    }

    const checkMobile = () => {
      try {
        const userAgent = navigator.userAgent || navigator.vendor || window.opera || '';
        const ua = userAgent.toLowerCase();
        
        // Check if it's a mobile device
        const isMobileDevice = /android|webos|iphone|ipod|blackberry|iemobile|opera mini/i.test(ua);
        
        // Check if it's a tablet (we want to exclude tablets)
        // iPad detection: check for iPad in user agent, or check for Mac with touch support (iPadOS 13+)
        const isIPad = /ipad/i.test(ua) || 
                      (navigator.platform === 'MacIntel' && navigator.maxTouchPoints > 1);
        const isTablet = isIPad || /android(?!.*mobile)|tablet/i.test(ua);
        
        // Check screen width (phones typically have smaller screens)
        const screenWidth = window.innerWidth || document.documentElement.clientWidth;
        
        // Consider it a phone if:
        // 1. It's a mobile device AND not a tablet
        // 2. AND has touch capability
        // 3. AND screen dimensions suggest a phone (not a tablet)
        const hasTouch = 'ontouchstart' in window || navigator.maxTouchPoints > 0;
        
        // Phones typically have smaller screens and higher aspect ratios
        const isLikelyPhone = screenWidth < 768 && hasTouch && !isTablet;
        const isPhone = (isMobileDevice && !isTablet && hasTouch) || isLikelyPhone;
        
        setShowRedirect(isPhone);
      } catch (error) {
        // If detection fails, don't show the redirect
        console.error('Error detecting mobile device:', error);
        setShowRedirect(false);
      }
    };

    checkMobile();
    window.addEventListener('resize', checkMobile);
    
    return () => {
      window.removeEventListener('resize', checkMobile);
    };
  }, []);

  if (!showRedirect) {
    return null;
  }

  const isIOS = /iPad|iPhone|iPod/.test(navigator.userAgent);
  const isAndroid = /Android/.test(navigator.userAgent);

  return (
    <div className="mobile-redirect-overlay">
      <div className="mobile-redirect-modal">
        <div className="mobile-redirect-content">
          <div className="mobile-redirect-header">
            <h2>FireWatch Mobile App</h2>
          </div>
          <div className="mobile-redirect-message">
            <p>For the best experience on mobile devices, please download our mobile app:</p>
          </div>
          <div className="mobile-redirect-buttons">
            {isIOS && (
              <a 
                href={APP_STORE_URL} 
                target="_blank" 
                rel="noopener noreferrer"
                className="mobile-redirect-button mobile-redirect-button-apple"
              >
                <span className="mobile-redirect-button-icon">📱</span>
                <span>Download on App Store</span>
              </a>
            )}
            {isAndroid && (
              <a 
                href={GOOGLE_PLAY_URL} 
                target="_blank" 
                rel="noopener noreferrer"
                className="mobile-redirect-button mobile-redirect-button-google"
              >
                <span className="mobile-redirect-button-icon">📱</span>
                <span>Get it on Google Play</span>
              </a>
            )}
            {!isIOS && !isAndroid && (
              <>
                <a 
                  href={APP_STORE_URL} 
                  target="_blank" 
                  rel="noopener noreferrer"
                  className="mobile-redirect-button mobile-redirect-button-apple"
                >
                  <span className="mobile-redirect-button-icon">📱</span>
                  <span>Download on App Store</span>
                </a>
                <a 
                  href={GOOGLE_PLAY_URL} 
                  target="_blank" 
                  rel="noopener noreferrer"
                  className="mobile-redirect-button mobile-redirect-button-google"
                >
                  <span className="mobile-redirect-button-icon">📱</span>
                  <span>Get it on Google Play</span>
                </a>
              </>
            )}
          </div>
          <div className="mobile-redirect-continue">
            <button 
              onClick={() => {
                try {
                  localStorage.setItem(STORAGE_KEY, 'true');
                } catch (error) {
                  console.error('Error saving to localStorage:', error);
                }
                setShowRedirect(false);
              }}
              className="mobile-redirect-continue-button"
            >
              Continue to Web Version
            </button>
          </div>
        </div>
      </div>
    </div>
  );
}

